<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader link-text="View our company history" link-href="/investors">
      <TextHeading variant="subtitle" color="secondary">About Us</TextHeading>
      <TextHeading
        variant="lg"
        block
      >From Bradford market stall to the UK’s 4th largest supermarket chain</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
      </PageSide>
      <PageMain>
        <iframe
          src="https://otp.tools.investis.com/clients/uk/morrison1/rns/regulatory-news.aspx?culture=en-GB"
          width="100%"
          height="1300px"
        />
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import PageMain from '../elements/PageMain.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'Investis',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    PageMain,
    TheFooter
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>